<regents-prep-non-transfer-wizard *ngIf="!isTransfer"></regents-prep-non-transfer-wizard>
<regents-prep-transfer-wizard *ngIf="isTransfer">Transfer</regents-prep-transfer-wizard>